<style scoped>
@import url("../assets/css/cj.css");
</style>

<template>
    <div :class="is_weixin || is_app?'':'common-home-content'">
      <div class="home-header" v-if="!is_weixin && !is_app">
            <button class="page-back" @click="pageback()"><span></span></button>
            <span class="title">智慧开方</span>
        </div>
        <div class="page-loading" v-show="!show">
            <div class="loading-content">
                <img src="../assets/images/page_loading.gif">
                <p class="loading-title">正在加载...</p>
            </div>
        </div>
        <div v-show="show">
            <div class="tab-container clearfix ice_bg">
                <div class="zhen-tabs">
                    <ul class="tabs-main clearfix">
                        <li><router-link class="a" to="/">症状</router-link></li>
                        <li><router-link class="a" to="/cj">疾病</router-link></li>
                        <li><router-link class="a actived" to="ks">科室</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="ice_bg space_pr pb15 space_pl">
                <ul class="zhen-depart clearfix">
                    <li class="fl"
                        :class="[department_name == department?'zhen-current-depart':'', (index+1) % 4 == 0?'border_r_none':'']"
                        v-for="(department, index) in locData.departments"
                        :key="index"
                    >
                        <div class="a zhen-group-disease"
                            :class="department.length >5?'font_1':''"
                            @click="changeDepartment(department)">
                            <span v-if="department == '耳鼻喉科'">耳鼻喉</span>
                            <span v-else-if="department == '传染病科'">传染科</span>
                            <span v-else-if="department == '精神病科'">精神科</span>
                            <span v-else>{{department}}</span>
                        </div>              
                    </li>
                </ul>

                <div
                    v-for="(categorie, index) in categories"
                    :key="index"   
                >
                    <h2 class="zhen-group-title word_sl font_2">{{categorie.name}}</h2>
                    <ul class="zhen-group clearfix">
                        <li class="fl"
                            v-for="(child, index) in categorie.value"
                            :key="index"
                        >
                            <div class="zhen-group-disease a"
                                @click="link(child.name)"
                            >
                                <span class="pr ib ellipsis">{{child.name}}</span>
                                <span class="free_icon_r" v-if="locData.free.indexOf(child.name) > -1"></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {deviceType} from '../utils/deviceType'
export default {
  data() {
    return {
      locData: {},
      categories: [],
      department_name: '内科',
      is_app: deviceType.isApp,
      is_weixin: deviceType.isWeiXin,
      show: false 
    };
  },
  created() {
      this.loadinit(this.department_name);
      window.appBack = ()=> this.pageback();
  },
  methods: {
      loadinit(department){
        var that = this;
        that.$api.get("/zhen/old/ks/"+department).then(function(res) {
            that.locData = res.data;
            that.categories = [];
            for(var k in that.locData.categories){
                that.categories.push({
                    name: k,
                    value: that.locData.categories[k]
                });
            }
            that.show = true;
        });
      },
      link(id){
          this.$router.push({ path: "/?q=" + id});
      },
      changeDepartment(department){
          if(department == this.department_name) return;
          this.department_name = department;
          this.loadinit(this.department_name);
      },
      pageback(){
          if(this.is_app){
              return null;
          }else{
              this.$router.push({ path: "/"});
          }
      } 
  }
}
</script>

